import { useState } from 'react';

import MenuIcon from 'components/icons/MenuIcon';
import ProfileIcon from 'components/icons/ProfileIcon';
import Button from '../Button/Button';
import Select from '../Select/Select';

import useAuth from 'providers/Auth/useAuth';
import useCourse from 'providers/Course/useCourse';
import { formatDateAndHour } from 'utils/func';
import { toast } from 'react-toastify';

import './header.scss';

const Header = ({ connectionState, toggleMenu, navState }) => {
  const [accountInformationsState, setAccountInformationsState] = useState(false);
  const { logout, user } = useAuth();
  const { courses, selectedCourseId, selectedCourse, selectCourse, reload } = useCourse();

  const canSwitchCourse = ['Admin', 'CPSAdmin'].includes(user?.roleName);

  const onSelectCourse = courseId => {
    if (+courseId === selectedCourseId) {
      return;
    }
    selectCourse(+courseId)
      .then(() => {
        toast.success('Course switched');
        // Recharge l'application pour recharger les données de la nouvelle course
        reload();
        window.location.reload();
      })
      .catch(err => toast.error(err?.response?.data?.message ?? 'Unable to switch course'));
  };

  return (
    <header>
      <div onClick={toggleMenu}>
        <MenuIcon active={navState} fill="#000" />
      </div>
      <div className="header-center">
        {canSwitchCourse && courses.length > 0 && (
          <div className="course-selector">
            <Select
              name="course"
              options={courses}
              value={selectedCourseId ?? ''}
              itemValue="id"
              itemLabel="name"
              onChange={value => onSelectCourse(value)}
            />
          </div>
        )}
        {!canSwitchCourse && selectedCourse && <span className="course-name">{selectedCourse.name}</span>}
      </div>
      <div>
        {/* <span className='connectionState'>{ connectionState.state }</span> */}
        <div onClick={() => setAccountInformationsState(!accountInformationsState)}>
          <ProfileIcon />
        </div>
      </div>
      {accountInformationsState && (
        <div className="accountInformations">
          <div className="accountInformations__content">
            <p>
              Logged as <span>{user.email}</span>
            </p>
            <p>
              Firstname: <span>{user.firstname}</span>
            </p>
            <p>
              Lastname: <span>{user.lastname}</span>
            </p>
            <p>
              <span>{user.roleName}</span>
            </p>
            {selectedCourse && (
              <p>
                Course: <span>{selectedCourse.name}</span>
              </p>
            )}
            <Button text="Logout" defaultStyle="primary less_padding" onClick={logout} />
            <p>
              Expire token : <span>{formatDateAndHour(new Date(user.exp * 1000))}</span>
            </p>
            <p>
              Version : <span>{process.env.REACT_APP_VERSION}</span>
            </p>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
